var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 16,
    viewBox: "0 0 71 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 16,
    rx: 2,
    fill: "#429400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 10.91V8.98H15.62V7.91H12.24V6.09H16.05V5H10.94V12H16.19V10.91H12.24ZM22.4192 5V9.74L18.5592 5H17.4892V12H18.7792V7.26L22.6392 12H23.7092V5H22.4192ZM30.6749 12H32.0349L28.8749 5H27.5949L24.4449 12H25.7849L26.4749 10.38H29.9749L30.6749 12ZM26.9149 9.36L28.2249 6.3L29.5449 9.36H26.9149ZM37.7352 8.36C38.2752 8.07 38.6352 7.54 38.6352 6.82C38.6352 5.71 37.7352 5 36.0552 5H32.7752V12H36.2552C38.0552 12 38.9952 11.3 38.9952 10.1C38.9952 9.19 38.4852 8.6 37.7352 8.36ZM35.9152 6.02C36.8152 6.02 37.3252 6.34 37.3252 6.99C37.3252 7.63 36.8152 7.95 35.9152 7.95H34.0752V6.02H35.9152ZM36.1752 10.98H34.0752V8.96H36.1752C37.1552 8.96 37.6852 9.27 37.6852 9.97C37.6852 10.67 37.1552 10.98 36.1752 10.98ZM40.2326 12H45.1926V10.9H41.5326V5H40.2326V12ZM47.3689 10.91V8.98H50.7489V7.91H47.3689V6.09H51.1789V5H46.0689V12H51.3189V10.91H47.3689ZM52.6181 12H55.6781C57.9481 12 59.4981 10.6 59.4981 8.5C59.4981 6.4 57.9481 5 55.6781 5H52.6181V12ZM53.9181 10.9V6.1H55.6181C57.1781 6.1 58.1881 7.05 58.1881 8.5C58.1881 9.95 57.1781 10.9 55.6181 10.9H53.9181Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusEnabled);
export default __webpack_public_path__ + "static/media/Status-ENABLED.efb5dd51.svg";
export { ForwardRef as ReactComponent };